import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { startTimeSync } from './time-sync';

// Block first paint until the initial /api/time round-trip lands so the
// scoreboard's elapsed math runs against an offset-corrected server
// clock from frame zero (eliminates the 1-2s drop the user saw on
// Start/Stop when their browser clock was off from the server).
startTimeSync().finally(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
